import { API_BASE_URL } from "@/lib/appEnvironment";

/**
 * Logout server-side (clears HttpOnly refresh cookie). Uses `fetch` to avoid a static import cycle
 * api ↔ store. If more store-called endpoints appear, consider a tiny `publicApi` wrapper
 * (base URL + credentials: "include", no interceptors).
 */
export function postLogoutRequest(): void {
  void fetch(`${API_BASE_URL}/auth/logout`, {
    method: "POST",
    credentials: "include",
  }).catch(() => undefined);
}
